import React from 'react';
import classNames from 'classnames';
import { DialogContent as MuiDialogContent } from '@material-ui/core';
import { makeStyles } from "../../styles/index";
var useStyles = makeStyles(function (theme) { return ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        padding: theme.spacing(3),
    },
}); }, { name: 'SnDialogContent' });
/**
 * ダイアログコンテント（内容）コンポーネント。
 */
export var DialogContent = function (props) {
    var classes = useStyles(props);
    return (React.createElement(MuiDialogContent, { className: classNames(classes.root, props.className), style: props.style }, props.children));
};
